import React from 'react';
import { Form } from 'react-bootstrap';

const RadioButton = ({
  radioId,
  label,
  checked,
  onChange,
  disabled,
  name,
  value,
  ...rest
}) => {

  return (
    <Form.Check
      type="radio"
      id={radioId}
      label={label}
      checked={checked}
      onChange={onChange}
      disabled={disabled}
      name={name}
      value={value}
      {...rest}
    />
  );
};

RadioButton.defaultProps = {
  label: '',
  checked: false,
  onChange: () => { },
  disabled: false,
  radioId: null,
};

export default RadioButton;
